<template>
  <div class="public_notes_wrap">
    <div class="public_notes_search">
      <el-input 
        v-model="studentName"
        clearable
        placeholder="请输入学生姓名或学号"
        prefix-icon="el-icon-search"
        @change="getSearch"
        maxlength="20"></el-input>
      <el-button class="go_back" @click="goBack">返回</el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
      <el-tab-pane label="今日公开笔记排行" name="first">
        <el-table
          v-if="activeName=='first'"
          :data="tableData"
          style="width: 100%;margin-top:16px"
          :header-cell-style="{background:'#EDF4FE'}"
          :height="height-160"
          class="collegeTable"
        >
          <el-table-column prop="num" label="名次"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="noteNum" label="公开笔记数"></el-table-column>
        </el-table>
        <pagination
          :currentpage="pageTotal.currentPage"
          :pageSize="pageTotal.pageSize"
          :total="pageTotal.total"
          layout="prev, pager, next, jumper"
          v-on:currentPageFn="currentPageFn"
          :current-page.sync="pageTotal.currentPage"
          v-if="tableData.length && (pageTotal.total>pageTotal.pageSize)"
        ></pagination>
      </el-tab-pane>
      <el-tab-pane label="公开笔记总数排行" name="second">
        <el-table
          v-if="activeName=='second'"
          :data="tableData"
          style="width: 100%;margin-top:16px"
          :header-cell-style="{background:'#EDF4FE'}"
          :height="height-160"
          class="collegeTable"
        >
          <el-table-column prop="num" label="名次"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="noteNum" label="公开笔记数"></el-table-column>
        </el-table>
        <pagination
          :currentpage="pageTotal.currentPage"
          :pageSize="pageTotal.pageSize"
          :total="pageTotal.total"
          layout="prev, pager, next, jumper"
          v-on:currentPageFn="currentPageFn"
          :current-page.sync="pageTotal.currentPage"
          v-if="tableData.length && (pageTotal.total>pageTotal.pageSize)"
        ></pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: '',
      height: window.innerHeight,
      tableData: [],
      pageTotal: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      studentName: '', //学生姓名或学号
    }
  },
  created() {
    this.activeName = this.$route.query.flag
    this.getList(this.activeName)
    // this.getNoteList()
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    getSearch(){
      console.log(this.studentName)
    },
    getList(flag){
      if(flag == 'first'){
        this.tableData = [
          {
            num: '1',
            name: '张三',
            noteNum: '11'
          },
          {
            num: '2',
            name: '张三',
            noteNum: '12'
          },
        ]
      }else{
        this.tableData = [
          {
            num: '1',
            name: '张三',
            noteNum: '13'
          },
          {
            num: '2',
            name: '李四',
            noteNum: '14'
          },
        ]
      }
    },
    getNoteList(){//笔记列表
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "pageNo": 1,
        "pageSize": 10,
        "param": ""
      }
      this.$ajax.post('/api-data/staUserNote/teacher/note/sort/', obj).then(rs=>{
        console.log(rs)
      })
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.activeName = tab.name
      this.getList(tab.name)
    },
    currentPageFn(){
      this.loading = true;
      this.pageTotal.currentPage = val;
    }
  },
}
</script>
<style lang="scss">
  .public_notes_wrap{
    margin: 0 16px;
    padding: 0 16px;
    background: #fff;
    box-sizing: border-box;
    position: relative;
    .el-tabs{
      margin-top: 16px;
      .el-tabs__active-bar{
        background-color: #333;
      }
      .el-tabs__item{
        height: 54px;
        line-height: 54px;
        flex: none;
      }
      .el-tabs__item.is-active{
        color: #333;
        font-weight: 600;
      }
    }
    /deep/ .public_notes_search{
      position: absolute;
      right: 16px;
      top: 16px;
      z-index: 9;
      display: flex;
      .el-input{
        width: inherit;
        margin-right: 16px;
      }
      .el-input__inner{
        width: 240px;
        height: 30px;
      }
      .el-input__icon{
        line-height: 30px;
      }
      .go_back{
        width:72px;
        height:30px;
        background:rgba(255,255,255,1);
        border:1px solid #5397F7;
        border-radius:4px;
        color: #5397F7;
        font-size: 12px;
        padding: 0;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/teacher/publicNotes.vue